export enum SiteEndpoints {
  GET_SITE = '/sites/:siteId',
}

export enum GroupEndpoints {
  GET_ALL_GROUPS = '/groups',
}
